import styled from 'styled-components'
import { P2 } from 'hopshopui'

export const ProfileLabel = styled(P2)`
  opacity: 0.75;
  flex: 1;
  max-width: 320px;
`

  